var map = {
	"./": [
		476,
		2
	],
	"./Terms": [
		465,
		2
	],
	"./Terms.js": [
		465,
		2
	],
	"./TermsDefault": [
		466,
		2
	],
	"./TermsDefault.js": [
		466,
		2
	],
	"./TermsIupp": [
		878,
		2
	],
	"./TermsIupp.js": [
		878,
		2
	],
	"./index": [
		476,
		2
	],
	"./index.js": [
		476,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1942;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/features/Terms lazy ^\.\/.*$
// module id = 1942
// module chunks = 14